import React from 'react';
import reqwest from 'reqwest';
import swal from '@sweetalert/with-react';

import settings from '../../../../settings';

import Editor from '../../../components/Editor';
import RightSide from '../../../components/FormArea/RightSide';
import Loader from '../../../components/Loader';
import Form from '../../../components/Form';
import Button from '../../../components/Button';
import Input from '../../../components/Inputs/Input';
import ContentBox from '../../../components/FormArea/ContentBox';
import Dropdown from '../../../components/Inputs/Dropdown';
import { faTimes, faSave } from '@fortawesome/pro-solid-svg-icons';
import File from '../../../components/Inputs/File';
import DataContainer from '../../../logic/dataContainer';

class SectorMagazineNew extends React.Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(/\/new$/, '');
    this.userRoles = JSON.parse(localStorage.getItem('userdata')).roles;

    this.state = {
      categories: [
        {
          label: 'Kategorie 1',
          value: '1',
        },
        {
          label: 'Kategorie 2',
          value: '2',
        },
        {
          label: 'Kategorie 3',
          value: '3',
        },
      ],
    };

    this.dataContainer = new DataContainer();
    this.dataContainer.add('Basic', {
      Guid: '',
      Typ: 'News',
    });
    this.dataContainer.add('General', {
      Type: 'SectorMagazine',
      Files: '',
      Title: '',
      Text: '',
      Priority: '',
      SendMail: 'false',
      Confirm: 'false',
      Released: 'false',
      AllowComments: 'true',
      ExpiryDateActive: 'false',
      ExpiryDate: '',
      Categories: [],
      Inform: '',
    });
    this.dataContainer.add('RightSide', {
      CreateDate: '',
      CreateUserGuid: '',
      CreateUserName: '',
      UpdateDate: '',
      UpdateUserGuid: '',
      UpdateUserName: '',
    });
  }

  save = async () => {
    const isValid = await this.form.validate();
    if (!isValid) {
      swal({
        title: 'Überprüfung fehlgeschlagen!',
        icon: 'error',
        text: 'Bitte überprüfen Sie Ihre Eingaben.',
      });
      return;
    }

    swal({
      title: 'Bitte warten...',
      content: <Loader text='Ihre Dateien werden hochgeladen und Ihr Branchenmgazin veröffentlicht!' />,
      button: { visible: false },
    });

    this.files.saveFiles().then(guids => {
      this.dataContainer.set('General', 'Files')(guids);
      reqwest({
        method: 'POST',
        url: settings.news.default.save,
        data: {
          Token: localStorage.getItem('token'),
          News: this.dataContainer.getStringified(),
        },
      }).then(() => {
        swal({
          title: 'Erfolgreich!',
          text: 'Ihr Branchenmgazin wurde erfolgreich gespeichert.',
          icon: 'success',
        });
        this.props.history.replace(this.parentRoute);
      });
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea'>
          <div className='FormArea-Top'>
            <p className='FormArea-Title'>Neues Branchenmgazin erstellen</p>
          </div>
          <div className='FormArea-Body'>
            <div className='FormArea-Body-Content'>
              <div className='FormArea-Body-Content-Center'>
                <div className='FormArea-Form'>
                  <div className='FormArea-Form-Left'>
                    <Form ref={node => (this.form = node)}>
                      <ContentBox title='Inhalt'>
                        <Dropdown
                          label='Kategorien:'
                          isSearchable
                          isMulti
                          name='Kategorien'
                          getSelected={value => {
                            this.dataContainer.set('General', 'Categories')(value);
                          }}
                          defaultValue={this.dataContainer.get('General', 'Categories')}
                          options={this.state.categories}
                          validator={[
                            {
                              required: true,
                              error: 'Bitte füllen Sie dieses Feld aus',
                            },
                          ]}
                        />
                        <Input
                          type='text'
                          label='Titel:'
                          validator={[
                            {
                              required: true,
                              error: 'Bitte füllen Sie dieses Feld aus',
                            },
                          ]}
                          onChange={value => {
                            this.dataContainer.set('General', 'Title')(value);
                          }}
                          name='Title'
                          defaultValue={this.dataContainer.get('General', 'Title')}
                        />
                        <Editor
                          editable
                          onChange={value => {
                            this.dataContainer.set('General', 'Text')(value);
                          }}
                          validator={[]}
                        >
                          {this.dataContainer.get('General', 'Text')}
                        </Editor>
                        <File
                          ref={node => (this.files = node)}
                          editable
                          name='files'
                          label='Anhänge:'
                          defaultFiles={this.dataContainer.get('General', 'Files')}
                          validator={[]}
                        />
                      </ContentBox>
                    </Form>
                  </div>
                  <RightSide>
                    <Button big icon={faTimes} to={this.parentRoute}>
                      Abbrechen
                    </Button>
                    <Button big type='primary' icon={faSave} onClick={this.save}>
                      Speichern
                    </Button>
                  </RightSide>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SectorMagazineNew;
